// extracted by mini-css-extract-plugin
module.exports = {"TopQuestions":"UxmjJdid","Title":"_16TWzFzd","Container":"dGWpapnX","QuestionContainer":"q9wIubZc","QuestionContainerNoBorder":"_17moVLhq","Question":"_3ZiW0JPA","Answer":"_1L8n9NRB","FAQLink":"_2lzIS0Wv","Icon":"_1qswKVj_"};
    if(module.hot) {
      // 1746735770071
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  